import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** cloud with a slash, offline. Decorative line icon; always pair with a visible text label. */
export function OfflineIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M4 4l16 16" />
      <path d="M8 17.5a3.9 3.9 0 0 1-.7-7.7 5.4 5.4 0 0 1 10.5-1.3 4.1 4.1 0 0 1-.8 9H8z" />
    </IconSvg>
  )
}
